import { type ISceneLoaderPluginExtensions, type ISceneLoaderPluginMetadata } from "core/index";

export const STLFileLoaderMetadata = {
    name: "stl",

    extensions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".stl": { isBinary: true },
    } as const satisfies ISceneLoaderPluginExtensions,
} as const satisfies ISceneLoaderPluginMetadata;
